import React from "react";
import "./common.scss";

const VerticalLine = props => <div {...props}></div>;

export default VerticalLine;
